var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px" } },
    [
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini" },
        },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "10px 10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: (_vm.colSpan * 4) / 6 } }, [
                _c("div", [
                  _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.IRCMB"))),
                  ]),
                  _vm._v("："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "darkslateblue",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataInfo.summary.cbmQty || 0))]
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini" },
        },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine1,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine2,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine3,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-data": _vm.lineChartDataLine4,
                      height: "350px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          staticStyle: { "padding-top": "50px" },
          attrs: { size: "mini" },
        },
        [
          _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("billingPage.IRTIM")) +
                  ": $" +
                  _vm._s(_vm.dataInfo.totalIncome)
              ),
            ]),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataBar1 },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataPie1 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          staticStyle: { "padding-top": "50px" },
          attrs: { size: "mini" },
        },
        [
          _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("billingPage.IRTCM")) +
                  ": $" +
                  _vm._s(_vm.dataInfo.totalCost)
              ),
            ]),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataBar2 },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataPie2 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          staticStyle: { "padding-top": "50px" },
          attrs: { size: "mini" },
        },
        [
          _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("billingPage.IRTGPM")) +
                  ": $" +
                  _vm._s(_vm.dataInfo.totalGrossProfit)
              ),
            ]),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataBar3 },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataPie3 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "saveForm1",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          staticStyle: { "padding-top": "50px" },
          attrs: { size: "mini" },
        },
        [
          _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("billingPage.IRTPMM")) +
                  ": $" +
                  _vm._s(_vm.dataInfo.totalProfitMargin)
              ),
            ]),
          ]),
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataBar4 },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c("LineChart", {
                    attrs: { "chart-data": _vm.lineChartDataPie4 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }